<template>
  <section>
    <b-form class="register-form custom-input-form preview" @submit.stop.prevent="onSubmit">
      <b-form-group
        :label="$t('form.name.label')"
        label-for="user-register-name"
        class="text-muted"
      >
        <b-input-group>
          <b-form-input
            id="user-register-name"
            v-model="form.name"
            name="user-register-name"
            :state="validateState('name')"
            aria-describedby="input-name-feedback"
            :placeholder="$t('form.name.label')"
            class="custom-form-input custom-form-input-class text-muted"
            @blur="onBlur('name')"
          ></b-form-input>
          <b-form-invalid-feedback id="input-name-feedback">
            {{ $t('message.error.requiredField') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>

      <b-form-group
        :label="$t('form.surname.label')"
        label-for="user-register-surname"
        class="text-muted"
      >
        <b-input-group>
          <b-form-input
            id="user-register-surname"
            v-model="form.surname"
            name="user-register-surname"
            :state="validateState('surname')"
            :placeholder="$t('form.surname.label')"
            class="custom-form-input custom-form-input-class text-muted"
            @blur="onBlur('surname')"
          >
            >
          </b-form-input>
          <b-form-invalid-feedback id="input-name-feedback">
            {{ $t('message.error.requiredField') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>

      <b-form-group
        :label="$t('form.email.label')"
        label-for="user-register-email"
        class="text-muted"
      >
        <b-input-group>
          <b-form-input
            id="user-register-email"
            v-model.trim="form.email"
            name="user-register-email"
            :state="validateState('email')"
            aria-describedby="input-email-feedback"
            :placeholder="$t('form.email.label')"
            class="custom-form-input custom-form-input-class text-muted"
            @blur="onBlur('email')"
          >
            >
          </b-form-input>
          <b-form-invalid-feedback id="input-email-feedback">
            {{ $t('message.error.invalidEmail') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>

      <div class="mb-4">
        <phone-number-form-group
          v-model="form.phone"
          :valid-state="form._invalidSave"
          :is-register="true"
          custom-class="register custom-form-input custom-form-input-class text-muted"
          @validate="validatePhone"
        ></phone-number-form-group>
        <small
          v-if="$v.form._isValidPhone.$dirty && !$v.form._isValidPhone.valid"
          class="invalid-feedback"
        >
          {{ $t('message.error.invalidPhone') }}
        </small>
      </div>

      <b-form-group class="d-none">
        <b-form-checkbox v-model="form.agree" :state="validateState('agree')">
          {{ $t('register.form.agree.label') }}
        </b-form-checkbox>
      </b-form-group>

      <div class="my-3">
        <b-button
          type="submit"
          class="btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
          :disabled="processing"
          variant="primary"
        >
          <p v-if="!processing">{{ $t('button.register.label') }}</p>

          <div v-if="processing">
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
          </div>
        </b-button>
      </div>
    </b-form>
  </section>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'SmartOeeUserRegisterForm',
  data() {
    return {
      form: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        agree: true,
        _isValidPhone: true,
        _invalidSave: false,
      },
      valid: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      _isValidPhone: {
        required,
        valid: (value) => value === true,
      },
      name: {
        required,
      },
      surname: {
        required,
      },
      phone: {
        required,
      },
      agree: {
        checked: (value) => value === true,
      },
    },
  },
  computed: {
    error() {
      return this.$store.getters.getError;
    },
    processing() {
      return this.$store.getters.getProcessing;
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated;
    },
  },
  watch: {
    isUserAuthenticated(val) {
      if (val) {
        this.$routerCore.GoToHomePage();
      }
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validatePhone(is) {
      this.form._isValidPhone = is;
    },
    onBlur(name) {
      this.$v.form[name].$touch();
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit('SET_PROCESSING', true);
      this.$emit('submit', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.register-form :deep {
  .error-icon-append {
    height: 48px;
    background-color: white;
    margin-left: -2px;
  }
  .form-group .form-control.custom-form-input-class,
  .custom-form-input-class.vue-tel-input {
    background-color: #fff !important;
    height: 48px;
  }
  .register.custom-form-input-class,
  .tel-input-wrapper .vti__dropdown.open,
  .tel-input-wrapper .vti__dropdown:hover,
  .tel-input-wrapper .vti__dropdown .vti__dropdown-list {
    background-color: white;
    z-index: 99999;
  }
  .tel-input-wrapper.register .vti__dropdown {
    padding-left: 0;
  }
  .tel-input-wrapper .vti__dropdown.open {
    border: none !important;
  }
  .tel-input-wrapper .vti__dropdown .vti__dropdown-list .vti__dropdown-item.highlighted {
    background-color: lightgrey;
  }
  .tel-input-wrapper .vti__dropdown .vti__dropdown-list {
    border: none;
    border-radius: 4px;
    margin-left: -19px;
    margin-top: 13px;
    max-width: 281px;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }

  .tel-input-wrapper.register .tel-input-input,
  .tel-input-wrapper.register .tel-input-input.tel-input-valid,
  .tel-input-wrapper.register .tel-input-input.tel-input-invalid {
    background-color: #fff !important;
  }
  .tel-input-wrapper .tel-input-input.tel-input-invalid:focus,
  .tel-input-wrapper .tel-input-input.tel-input-valid:focus {
    outline: none;
  }
  .form-group label {
    font-size: 16px;
  }
  .delete-margin-block {
    margin-bottom: 0;
  }
  .custom-control-label::before {
    background-color: #191c24;
    border: 2px solid #979ba7;
  }
  small.invalid-feedback {
    display: block;
  }
}
</style>
